"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuSectionImpl = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_aria_1 = require("react-aria");
const internal_1 = require("./");
const Css_1 = require("../../Css");
const utils_1 = require("../../utils");
function MenuSectionImpl(props) {
    const { section, state, onClose, contrast } = props;
    const { itemProps, groupProps } = (0, react_aria_1.useMenuSection)(props.section);
    const { separatorProps } = (0, react_aria_1.useSeparator)({ elementType: "li" });
    const isPersistentSection = section.key !== state.collection.getFirstKey();
    const tid = (0, utils_1.useTestIds)(props);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isPersistentSection && (0, jsx_runtime_1.jsx)("li", { ...separatorProps, css: Css_1.Css.bt.bGray200.$ }), (0, jsx_runtime_1.jsx)("li", { ...itemProps, css: Css_1.Css.if(!isPersistentSection).overflowAuto.if(contrast).white.$, children: (0, jsx_runtime_1.jsx)("ul", { css: Css_1.Css.listReset.$, ...groupProps, ...tid[isPersistentSection ? "persistentItems" : "menuItems"], children: [...section.childNodes].map((item) => ((0, jsx_runtime_1.jsx)(internal_1.MenuItemImpl, { item: item, state: state, onClose: onClose, contrast: contrast, ...tid }, item.key))) }) })] }));
}
exports.MenuSectionImpl = MenuSectionImpl;
